import {
	Text,
	Select as ChakraSelect,
	type SelectProps as ChakraSelectProps,
	Box,
} from "@chakra-ui/react";
import { forwardRef, useState } from "react";

const Select = forwardRef<
	HTMLSelectElement,
	ChakraSelectProps & {
		noEmpty?: boolean;
		setValue?: (value?: string) => void;
	}
>(
	(
		{
			children,
			placeholder,
			id,
			name,
			onChange,
			onBlur,
			noEmpty = false,
			value: outerValue,
			setValue: setOuterValue,
			...props
		},
		ref,
	) => {
		const [innerValue, setInnerValue] = useState(props.defaultValue);
		const value = outerValue ?? innerValue;
		const setValue = setOuterValue ?? setInnerValue;
		const handleOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
			setValue(event.target.selectedOptions[0].value);
			if (onChange) {
				onChange(event);
			}
		};

		const handleOnBlur = (event: React.FocusEvent<HTMLSelectElement>) => {
			if (onBlur) {
				onBlur(event);
			}
		};

		return (
			<Box className="">
				<ChakraSelect
					ref={ref}
					name={name}
					value={value}
					defaultValue={props.defaultValue}
					id={id}
					mt={props.mt}
					onChange={handleOnChange}
					onBlur={handleOnBlur}
					w={props.w}
				>
					{noEmpty === false && <option value="">---</option>}
					{children}
				</ChakraSelect>
				<Text
					position="relative"
					top="-40px"
					marginBottom="-25px"
					left="5px"
					transform="translate(10px,-10px) scale(0.8)"
					color="gray.500"
					px={1}
					transformOrigin="top left"
					transition="all .2s ease-out"
					pointerEvents="none"
					bg="white"
					w="fit-content"
					h="fit-content"
					zIndex={5}
				>
					{placeholder}
				</Text>
			</Box>
		);
	},
);

export default Select;
